module.exports = __webpack_public_path__ + "img/1515054443.e3626f8a.jpg";